// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --retail-kad-svg-first-width: 914px;
  --retail-kad-svg-first-height: 312px;
  --retail-kad-svg-second-width: 920px;
  --retail-kad-svg-second-height: 278px;
  --retail-kad-svg-third-width: 920px;
  --retail-kad-svg-third-height: 360px;
  --retail-kad-svg-fourth-width: 920px;
  --retail-kad-svg-fourth-height: 360px;
  --retail-kad-svg-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.1);
  --retail-kad-svg-mr: 20px;
  --retail-kad-test-mb: -20px;
}

.retail-kad-qualtrics-slide-button {
  margin-top: -10px;
}

.retail-kad-slide {
  width: 925px;
  height: 370px;
}

.retail-kad-slide-image-wrapper {
  box-shadow: var(--retail-kad-svg-shadow);
  border-radius: 20px;
}

.retail-kad-slide-image-first {
  width: var(--retail-kad-svg-first-width);
  height: var(--retail-kad-svg-first-height);
}

.retail-kad-slide-image-second {
  width: var(--retail-kad-svg-second-width);
  height: var(--retail-kad-svg-second-height);
}

.retail-kad-slide-image-third {
  width: var(--retail-kad-svg-third-width);
  height: var(--retail-kad-svg-third-height);
}

.retail-kad-slide-image-fourth {
  width: var(--retail-kad-svg-fourth-width);
  height: var(--retail-kad-svg-fourth-height);
}

.first-image-retail-slide {
  border-radius: 8px;
}

.slide-body {
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.25px;
  vertical-align: middle;
}

.retail-kad-slide-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.retail-kad-slide-text {
  margin-bottom: 1rem; /* Add spacing between text and button */
}
`, "",{"version":3,"sources":["webpack://./src/components/retail-slides/slide-wrapper/SlideWrapper.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,oCAAoC;EACpC,qCAAqC;EACrC,mCAAmC;EACnC,oCAAoC;EACpC,oCAAoC;EACpC,qCAAqC;EACrC,4DAA4D;EAC5D,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;EACE,wCAAwC;EACxC,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB,EAAE,wCAAwC;AAC/D","sourcesContent":[":root {\n  --retail-kad-svg-first-width: 914px;\n  --retail-kad-svg-first-height: 312px;\n  --retail-kad-svg-second-width: 920px;\n  --retail-kad-svg-second-height: 278px;\n  --retail-kad-svg-third-width: 920px;\n  --retail-kad-svg-third-height: 360px;\n  --retail-kad-svg-fourth-width: 920px;\n  --retail-kad-svg-fourth-height: 360px;\n  --retail-kad-svg-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.1);\n  --retail-kad-svg-mr: 20px;\n  --retail-kad-test-mb: -20px;\n}\n\n.retail-kad-qualtrics-slide-button {\n  margin-top: -10px;\n}\n\n.retail-kad-slide {\n  width: 925px;\n  height: 370px;\n}\n\n.retail-kad-slide-image-wrapper {\n  box-shadow: var(--retail-kad-svg-shadow);\n  border-radius: 20px;\n}\n\n.retail-kad-slide-image-first {\n  width: var(--retail-kad-svg-first-width);\n  height: var(--retail-kad-svg-first-height);\n}\n\n.retail-kad-slide-image-second {\n  width: var(--retail-kad-svg-second-width);\n  height: var(--retail-kad-svg-second-height);\n}\n\n.retail-kad-slide-image-third {\n  width: var(--retail-kad-svg-third-width);\n  height: var(--retail-kad-svg-third-height);\n}\n\n.retail-kad-slide-image-fourth {\n  width: var(--retail-kad-svg-fourth-width);\n  height: var(--retail-kad-svg-fourth-height);\n}\n\n.first-image-retail-slide {\n  border-radius: 8px;\n}\n\n.slide-body {\n  font-weight: 400;\n  line-height: 150%;\n  letter-spacing: 0.25px;\n  vertical-align: middle;\n}\n\n.retail-kad-slide-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.retail-kad-slide-text {\n  margin-bottom: 1rem; /* Add spacing between text and button */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
